import { whitelistBlacklistApi } from "@application/api/endpoints/whitelistBlackListVehicle-api";
import { createAction } from "@reduxjs/toolkit";
export const vehicleDetailFetchStart = createAction('vehicle/detailFetchStart');
export const vehicleDetailFetchSuccess = createAction('vehicle/detailFetchSuccess');
export const vehicleDetailFetchFailure = createAction('vehicle/detailFetchFailure');
export const vehicleUpdateStart = createAction('vehicle/updateStart');
export const vehicleUpdateSuccess = createAction('vehicle/updateSuccess');
export const vehicleUpdateFailure = createAction('vehicle/updateFailure');
export const vehicleDeleteStart = createAction('vehicle/deleteStart');
export const vehicleDeleteSuccess = createAction('vehicle/deleteSuccess');
export const vehicleDeleteFailure = createAction('vehicle/deleteFailure');
export const deleteVehicleDetailAction = (vehicleDetailId) => async (dispatch) => {
    dispatch(vehicleDeleteStart());
    try {
        const response = await whitelistBlacklistApi.deleteVehicleDetail(vehicleDetailId);
        dispatch(vehicleDeleteSuccess(response));
        return response;
    }
    catch (error) {
        dispatch(vehicleDeleteFailure(error.message || 'Vehicle deletion failed'));
    }
};
export const fetchVehicleDetailAction = (vehicleDetailId) => async (dispatch) => {
    dispatch(vehicleDetailFetchStart());
    try {
        const response = await whitelistBlacklistApi.getVehicleDetail(vehicleDetailId);
        dispatch(vehicleDetailFetchSuccess(response));
        return response;
    }
    catch (error) {
        dispatch(vehicleDetailFetchFailure(error.message || 'Vehicle fetch failed'));
    }
};
export const updateVehicleDetail = (vehicleId, vehicleData) => async (dispatch) => {
    dispatch(vehicleUpdateStart());
    try {
        const response = await whitelistBlacklistApi.updateVehicleDetail(vehicleId, vehicleData);
        if (response.isSuccess) {
            dispatch(vehicleUpdateSuccess(response.data));
            return response;
        }
        else {
            dispatch(vehicleUpdateFailure(response));
            return response;
        }
    }
    catch (error) {
        dispatch(vehicleUpdateFailure(error.message || 'Vehicle update failed'));
    }
};
